import Link from 'components/CustomRoutingLink';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {formatRating} from 'core/helpers';
import React from 'react';
import cs from 'classnames';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Typography} from 'components/Typography';

type TSimpleRating = {
    value: number;
    reviewsCount: number;
    reviewsUrl: string;
    onClick: IProductSnippet['analytics']['onReviewsClick'];
};

export const SimpleRating = (props: TSimpleRating) => {
    const {value, reviewsCount, reviewsUrl, onClick} = props;

    return (
        <Link className={cs(style.rating)} href={reviewsUrl} onClick={onClick}>
            <Icon icon={'star_filled'} />
            <Typography variant={'label-10-r'} className={style.rating__count}>
                {formatRating(value)}
            </Typography>
            <Typography variant={'label-10-r'}>•</Typography>
            <Typography variant={'label-10-r'} className={style.rating__reviews}>
                {reviewsCount}
            </Typography>
        </Link>
    );
};
